__turbopack_context__.v({
  "button": "InputSearch-module-scss-module__9k4aNW__button",
  "combobox": "InputSearch-module-scss-module__9k4aNW__combobox",
  "comboboxBgSurface": "InputSearch-module-scss-module__9k4aNW__comboboxBgSurface",
  "comboboxLimitWidth": "InputSearch-module-scss-module__9k4aNW__comboboxLimitWidth",
  "fade-in": "InputSearch-module-scss-module__9k4aNW__fade-in",
  "groupLabel": "InputSearch-module-scss-module__9k4aNW__groupLabel",
  "iconLabel": "InputSearch-module-scss-module__9k4aNW__iconLabel",
  "input": "InputSearch-module-scss-module__9k4aNW__input",
  "inputWrapper": "InputSearch-module-scss-module__9k4aNW__inputWrapper",
  "list": "InputSearch-module-scss-module__9k4aNW__list",
  "loader": "InputSearch-module-scss-module__9k4aNW__loader",
  "no-transform": "InputSearch-module-scss-module__9k4aNW__no-transform",
  "option": "InputSearch-module-scss-module__9k4aNW__option",
  "optionActive": "InputSearch-module-scss-module__9k4aNW__optionActive",
  "optionCount": "InputSearch-module-scss-module__9k4aNW__optionCount",
  "rotate": "InputSearch-module-scss-module__9k4aNW__rotate",
});
